import React, { Component } from "react";
import { TextArea } from "carbon-components-react";
import { connect } from "react-redux";

import { sdg1633Actions } from "../../../../../../_actions";

class Other extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  state = {};

  handleChange(e) {
    const { dispatch } = this.props;

    dispatch(
      sdg1633Actions.updateMetadataField(e.target.name, e.target.value)
    );
  }

  render() {
    return (
      <React.Fragment>
        <div className="box-header with-border">
          <h3 className="box-title metadata-title">Other</h3>
        </div>
        <div className="box-body with-border">
          <div
            className="row"
            style={{ display: "flex", marginBottom: "15px" }}
          >
            <div className="col-sm-8 adaptive-form">
              <TextArea
                maxCount={1000}
                enableCounter
                id="other_notes"
                name="other_notes"
                value={
                  this.props.data && this.props.data["other_notes"]
                    ? this.props.data["other_notes"]
                    : ""
                }
                labelText="20. Other methodological notes / deviations from global metadata"
                onChange={this.handleChange}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { data } = state.sdg1633State;

  return {
    data
  };
}

const connectedOther = connect(mapStateToProps)(Other);

export { connectedOther as Other };
